import { render, staticRenderFns } from "./warehouseinfo.vue?vue&type=template&id=aea2f254"
import script from "./warehouseinfo.vue?vue&type=script&lang=js"
export * from "./warehouseinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports